/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventDto } from '../../models/webhook-event-dto';
import { WebhookEventFilter } from '../../models/webhook-event-filter';

export interface WebhooksMonitoringEventsPost$Plain$Params {
      body?: WebhookEventFilter
}

export function webhooksMonitoringEventsPost$Plain(http: HttpClient, rootUrl: string, params?: WebhooksMonitoringEventsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEventDto>>> {
  const rb = new RequestBuilder(rootUrl, webhooksMonitoringEventsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WebhookEventDto>>;
    })
  );
}

webhooksMonitoringEventsPost$Plain.PATH = '/webhooks/monitoring/events';
